<template>
	<form class="form-horizontal" @submit.prevent="updateBasicUserDetails">
		<div class="row">
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">First Name
			</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="text" class="form-control" v-model.trim="customer.firstName">
				</div>
			</div>
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Last Name
			</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="text" class="form-control" v-model.trim="customer.lastName">
				</div>
			</div>
		</div>
		<div class="row">
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Company Name</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="text" class="form-control" v-model.trim="customer.companyName">
				</div>
			</div>
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">IP Address
			</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="text" class="form-control" v-model.trim="customer.ip">
				</div>
			</div>
		</div>
		<div class="row">
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Address Line 1
			</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="text" class="form-control" v-model.trim="customer.addrLine1">
				</div>
			</div>
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Address Line 2</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="text" class="form-control" v-model.trim="customer.addrLine2">
				</div>
			</div>
		</div>
		<div class="row">
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">City
			</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="text" class="form-control" v-model.trim="customer.city">
				</div>
			</div>
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">State/Province
			</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="text" class="form-control" v-model.trim="customer.state">
				</div>
			</div>
		</div>
		<div class="row">
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Postal Code
			</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="text" class="form-control" v-model.trim="customer.postalCode">
				</div>
			</div>
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Affiliate ID (if any)</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="number" class="form-control" v-model.trim="customer.affiliateID">
				</div>
			</div>
		</div>
		<div class="row">
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Country Name
			</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="text" class="form-control" v-model.trim="customer.countryName">
				</div>
			</div>
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Country Code
			</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="text" class="form-control" v-model.trim="customer.countryCode">
				</div>
			</div>
		</div>
    <div class="row"><br>
      <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Language
      </label>
      <div class="col-sm-4 col-md-4 col-lg-4">
        <div class="form-group">
          <input type="text" class="form-control" v-model.trim="customer.language">
        </div>
      </div>
      <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">UUID
      </label>
      <div class="col-sm-4 col-md-4 col-lg-4">
        <div class="form-group">
          <input disabled type="text" class="form-control" v-model.trim="customer.uuid">
        </div>
      </div>
    </div>
		<div class="row">
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Customer ID#
			</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="number" class="form-control" v-model.trim="customer.id">
				</div>
			</div>
      <label class="col-sm-2 col-md-2 col-lg-2 col-form-label" for="backupWaiting">Backup Waiting Limit
			</label>
			<div class="col-sm-4 col-md-4 col-lg-4 d-flex align-items-center">
        <switch-control v-model="customer.enableBackupTime" id="backupWaiting" @change="customer.enableBackupTime = !customer.enableBackupTime"/>
			</div>
		</div>
		<div v-if="customer.emailSetup" class="row">
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Email Username
			</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="text" class="form-control" v-model.trim="customer.emailUsername">
				</div>
			</div>
      <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Account Created At:
			</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
        <label class="badge badge-success text-white mt-10" >
          {{parseCreatedAt(customer.createdAt)}}
        </label>
			</div>
		</div>
    <div class="row">
        <label class="col-sm-2 col-md-2 col-lg-2 col-form-label pt-2" for="storageAlerts">
          Storage Email Alerts
        </label>
      <div class="col-sm-4 col-md-4 col-lg-4 d-flex align-items-center">
      <switch-control v-model="userStorageEmailAlerts" id="storageAlerts" @change="userStorageEmailAlerts = !userStorageEmailAlerts"/>
      </div>
    </div>

		<div class="row">
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Welcome Email Delivery:</label>
			<div class="col-sm-12 col-md-5 col-lg-5 mt-2">
				<section v-if="isWelcomeEmailSent">
					<label class="badge badge-success text-white" >
						<i class="fa fa-check"></i>
						Delivered On Address: {{customer.welcomeEmailAddress}}
					</label>
					<small class="ml-2">
						<a href="javascript:void(0)" @click="sendWelcomeEmail()" v-if="!loading">Re-Send Welcome Email?</a>
						<div class="loader mini_loader" style="display: inline-flex" v-else></div>
					</small>
					<small class="ml-2">
						<a href="javascript:void(0)" v-if="!loadingPasswordReset" @click="sendPasswordResetEmail()">Send Password Reset Link?</a>
						<div class="loader mini_loader" style="display: inline-flex" v-else></div>
					</small>
          <small class="ml-2">
						<a href="javascript:void(0)" v-if="!loadingLink" @click="generateLink()">Generate Link?</a>
						<div class="loader mini_loader" style="display: inline-flex" v-else></div>
					</small>
				</section>
				<section v-else>
					<label class="badge badge-danger text-white">
						Un-Delivered
					</label>
					<small class="ml-2">
						<a href="javascript:void(0)" @click="sendWelcomeEmail()" v-if="!loading">Send Welcome Email?</a>
						<div class="loader mini_loader" style="display: inline-flex" v-else></div>
					</small>
					<small class="ml-2">
						<a href="javascript:void(0)" v-if="!loadingPasswordReset" @click="sendPasswordResetEmail()">Send Password Reset Link?</a>
						<div class="loader mini_loader" style="display: inline-flex" v-else></div>
					</small>
          <small class="ml-2">
            <a href="javascript:void(0)" v-if="!loadingLink" @click="generateLink()">Generate Link?</a>
            <div class="loader mini_loader" style="display: inline-flex" v-else></div>
          </small>
				</section>
			</div>
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Last Password Reset:</label>
			<div class="col-sm-12 col-md-3 col-lg-3 mt-2">
				<section v-if="customer.lastPasswordReset">
					<label class="badge badge-success text-white" >
						{{lastPasswordResetDate | formatDate}}
					</label>
				</section>
				<section v-else>
					<label class="badge badge-danger text-white">
						N/A
					</label>
				</section>
			</div>
		</div>

<!--    <div class="row mt-4">-->
<!--      <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">New Backup Process-->
<!--      </label>-->
<!--      <div class="col-sm-4 col-md-4 col-lg-4">-->
<!--        <div class="form-group">-->
<!--          <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : customer.enableNewBackupProcess, 'bootstrap-switch-off bootstrap-switch-focused' : !customer.enableNewBackupProcess }">-->
<!--            <div class="bootstrap-switch-container" @click="(backupProcessHandlers.includes(user.email)) && (customer.enableNewBackupProcess = !customer.enableNewBackupProcess)">-->
<!--              <span class="bootstrap-switch-handle-on bootstrap-switch-primary">yes</span>-->
<!--              <span class="bootstrap-switch-label"></span>-->
<!--              <span class="bootstrap-switch-handle-off bootstrap-switch-default">No</span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Old Backup Process-->
<!--      </label>-->
<!--      <div class="col-sm-4 col-md-4 col-lg-4">-->
<!--        <div class="form-group">-->
<!--          <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : customer.enableOldBackupProcess, 'bootstrap-switch-off bootstrap-switch-focused' : !customer.enableOldBackupProcess }">-->
<!--            <div class="bootstrap-switch-container" @click="(backupProcessHandlers.includes(user.email)) && (customer.enableOldBackupProcess = !customer.enableOldBackupProcess)">-->
<!--              <span class="bootstrap-switch-handle-on bootstrap-switch-primary">yes</span>-->
<!--              <span class="bootstrap-switch-label"></span>-->
<!--              <span class="bootstrap-switch-handle-off bootstrap-switch-default">No</span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
		<br>
		<div class="row">
			<label class="col-sm-2 col-form-label"></label>
			<div class="col-sm-10">
				<div class="form-group">
					<button type="submit" class="btn btn-danger">Update Basic Details of the User</button>
				</div>
			</div>
		</div>
	</form>
</template>

<script>
	import {db, functions, auth} from "@/firebase/init";
	import swal from 'sweetalert2';
	import randomstring from 'randomstring';
  import copyButtonMixin from '../../../../mixins/copyButtonMixin';
  import moment from 'moment'
  import customer from "../../../../store/modules/customer";
  import SwitchControl from "@/components/inputs/SwitchControl.vue";
  import backupList from "@/components/User/Backup/BackupList.vue";
  export default {
		name: "BasicDetailsUpdate",
    components: {SwitchControl},
		/* props: {
		  custDetails: Object
		  }, */
    mixins: [copyButtonMixin],
		data() {
			return {
        backupProcessHandlers: ['sara@bigscoots.com','rao@bigscoots.com', 'khan@bigscoots.com', 'justin@bigscoots.com'],
				loading: false,
				loadingPasswordReset: false,
        previousCustomerId: null,
        loadingLink: false,
				// customer: this.$store.getters["customer/details"]
			};
		},
		computed: {
      backupList() {
        return backupList
      },

			customer () {
				return this.$store.getters["customer/details"];
			},
      userStorageEmailAlerts: {
        get() {
          return this.customer.storageEmailAlerts;
        },
        set(value) {
          this.$store.dispatch("customer/storageAlertUpdate", {
            storageEmailAlerts: value
          });
        }
      },
			isWelcomeEmailSent(){
				return this.$store.getters["customer/welcomeEmailSent"]
			},
			lastPasswordResetDate() {
				return this.$store.getters['customer/getLastPasswordReset'];
			}
		},
		mounted() {
			console.log(this.customer.id);
			this.previousCustomerId = this.customer.id
		},
		methods: {
      parseCreatedAt(date) {
        let newDate = new Date(date);
        newDate = moment(newDate);
        return newDate.format('DD MMM YYYY, hh:mm a');
      },
			checkUndefined(data) {
				if (typeof data === "undefined" || data === null) {
					return "";
				} else {
					return data;
				}
			},
      async generateLink(data){
        if (this.loadingLink) {
          return
        }
        this.loadingLink = true
        console.log(this.customer)
        try {
          const response = await this.$http.post('/utilities/generate-reset-password-link', {
            uid: this.customer.docID,
            email: this.customer.email,
            grant_type: 'token',
          });
          console.log(data)
          this.doCopy(response.data.link);
          swal('Copied!', 'Set password link has been copied!', 'success');
        } catch (e) {
          console.log(e.toString());
          console.log('Error in generating link')
          swal('Error!', 'Error in generating link!', 'error');

        }
        this.loadingLink = false
      },
      async sendPasswordResetEmail(){
				try{
					console.log('Sending password reset email to: ' + this.customer.email);
					this.loadingPasswordReset = true;
					await auth.sendPasswordResetEmail(this.customer.email);
					swal('Success!', 'Password reset link has been sent to email: ' + this.customer.email, 'success');
					this.loadingPasswordReset = false;
				}catch (e) {
					console.error(e);
					swal('Error', 'Some thing went wrong: ' + e, 'error');
				}
			},
			updateBasicUserDetails() {
				// Check all the required fields are filled properly before submitting else show error
				// if (
				// 	this.customer.firstName &&
				// 	this.customer.lastName &&
				// 	this.customer.ip &&
				// 	this.customer.addrLine1 &&
				// 	this.customer.city &&
				// 	this.customer.state &&
				// 	this.customer.postalCode &&
				// 	this.customer.countryName &&
				// 	this.customer.countryCode &&
				// 	this.customer.language
				// ) {
					// Set asyncDone to false
					this.$store.dispatch("async/stateUpdate", {state: false});

					// Update the changed records to the firestore database
					db
						.collection("users")
						.doc(this.customer.docID)
						.update({
							firstName: this.checkUndefined(this.customer.firstName),
							lastName: this.checkUndefined(this.customer.lastName),
							companyName: this.checkUndefined(this.customer.companyName),
							ip: this.checkUndefined(this.customer.ip),
							addrLine1: this.checkUndefined(this.customer.addrLine1),
							addrLine2: this.checkUndefined(this.customer.addrLine2),
							city: this.checkUndefined(this.customer.city),
							state: this.checkUndefined(this.customer.state),
							postalCode: this.checkUndefined(this.customer.postalCode),
							affiliateID: this.checkUndefined(this.customer.affiliateID),
							countryName: this.checkUndefined(this.customer.countryName),
							countryCode: this.checkUndefined(this.customer.countryCode),
							language: this.checkUndefined(this.customer.language),
              customerID: this.checkUndefined(this.customer.id),
              enableBackupTime: !!(this.customer.enableBackupTime === undefined || this.customer.enableBackupTime),
              enableNewBackupProcess: !!this.customer.enableNewBackupProcess,
              emailUsernames: {
                domain: this.checkUndefined(this.customer.emailPrimaryDomain),
                username: this.checkUndefined(this.customer.emailUsername)
              },
              storageEmailAlerts: this.checkUndefined(this.customer.storageEmailAlerts),
              updatedAt: Date.now()
						})
						.then(async () => {
							// Update the changed customer details to the Vuex state
							this.$store.dispatch("customer/basicDetailsUpdate", {
								firstName: this.customer.firstName,
								lastName: this.customer.lastName,
								companyName: this.customer.companyName,
								ip: this.customer.ip,
								addrLine1: this.customer.addrLine1,
								addrLine2: this.customer.addrLine2,
								city: this.customer.city,
								state: this.customer.state,
								postalCode: this.customer.postalCode,
								affiliateID: this.customer.affiliateID,
								countryName: this.customer.countryName,
								countryCode: this.customer.countryCode,
								language: this.customer.language,
                enableBackupTime: this.customer.enableBackupTime === undefined ? true : this.customer.enableBackupTime,
                enableNewBackupProcess: !!this.customer.enableNewBackupProcess,
                emailUsernames: {
                  domain: this.checkUndefined(this.customer.emailPrimaryDomain),
                  username: this.checkUndefined(this.customer.emailUsername)
                },
                storageEmailAlerts: this.checkUndefined(this.customer.storageEmailAlerts),
							});
              console.log('updating accounts in algolia')
              // update indices in algolia
              await this.$http.post('/algolia/reinitialize-user-all-record', {
                grant_type: 'token',
                uid : this.customer.docID,
              });

							// Set asyncDone to true
							this.$store.dispatch("async/stateUpdate", {state: true});

							// Show the alert for 5 sec
							this.$store.dispatch("alert/update", {
								type: "success",
								message: `The basic user details of the Customer (Cust ID#: ${
									this.customer.id
									}) has been updated successfully.`,
								show: true
							});
							this.addLog({
                message: `The basic user details of the Customer (Cust ID#: ${
                    this.customer.id
                }) has been updated successfully.`,
                level: "info"
              })

							setTimeout(() => {
								this.$store.dispatch("alert/showUpdate", {show: false});
							}, 5000);
						})
						.catch(err => {
							// Set asyncDone to true
							this.$store.dispatch("async/stateUpdate", {state: true});

							// Show the alert for 5 sec
							this.$store.dispatch("alert/update", {
								type: "danger",
								message: err,
								show: true
							});
              this.addLog({
                message: err,
                level: "danger"
              })
							setTimeout(() => {
								this.$store.dispatch("alert/showUpdate", {show: false});
							}, 5000);
						});
				// } else {
				// 	// Show the alert for 5 sec
				// 	this.$store.dispatch("alert/update", {
				// 		type: "danger",
				// 		message:
				// 			"Please make sure that all the required fields are filled properly",
				// 		show: true
				// 	});
				//
				// 	setTimeout(() => {
				// 		this.$store.dispatch("alert/showUpdate", {show: false});
				// 	}, 5000);
				// }
			},
			sendWelcomeEmail() {
				swal({
					title: "Are you sure?",
					html: "Do you want to send the welcome email to user: <b>" + this.customer.firstName + ' ' + this.customer.lastName + '</b> on email' +
							': <b>'+this.customer.email+'</b><br/>' +
							'<span class="text-danger">Please note: <b>This action will update the existing password of user an generate a new one for admin.</b></span>',
					type: "warning",
					confirmButtonText: "Send",
					confirmButtonColor: "#6ACF98",
					showCancelButton: true,
					cancelButtonText: "Cancel",
					cancelButtonColor: "#EE8057"
				}).then(async res => {
					if(res.value) {
						console.log('Sending Welcome Email...');
						this.loading = true;
						this.$http.post('/utilities/send-welcome-email', {
							grant_type: 'token',
							userEmail: this.customer.email,
							fullName: this.customer.firstName + ' ' + this.customer.lastName,
							UID: this.customer.docID
						}).then(async () => {
							const randomPassword = randomstring.generate(16);
							await this.$store.commit('customer/welcomeEmailMutate', this.customer.email);
							// const updateAuthPassword = functions.httpsCallable(
							// 		"updateAuthPassword"
							// );
              //
							// updateAuthPassword({
							// 	uid: this.customer.docID,
							// 	newPassword: randomPassword
							// })
              this.$http.post("/auth/update-auth-password", {
                uid: this.customer.docID,
                newPassword: randomPassword,
                grant_type: 'token',
              }).then(result => {
								if (result.data.success) {
									this.$store.commit('customer/lastPasswordResetMutate', result.data.lastPasswordResetDate);
									swal({
										title: 'New Password Assigned',
										html: 'New generated password for this user is: <b>' + randomPassword + '</b>',
										type: 'success'
									});
								}
								this.loading = false;
							}).catch((err) => {
								console.error(err);
								this.loading = false;
								swal('Error!', 'There is an error in assigning the new password for this user.', "error");
							});
						}).catch(() => {
							swal('Error', 'Error in sending welcome email', "error");
							this.loading = false;
						});

					}
				});
			}
		}
	};
</script>
